// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"380":"7b3a7f2f","499":"6351a5df"}[chunkId] + ".chunk.css";
};